import React from "react";
import Icon from "src/assets/cimdef-logo.svg";
const Header = () => (React.createElement("header", null,
    React.createElement("a", { title: "Home", href: "/" },
        React.createElement(Icon, null)),
    React.createElement("span", { className: "subhead" },
        React.createElement("h2", null, "CIMDEF is an internal tool made by employees for employees to look up acronyms and terms relevant to the tech industry and specific to Comcast NBCUniversal Sky."))));
export default Header;
